import React from 'react'
import { Grid } from '@material-ui/core'
import PageLayout from '../../common/PageLayout'
import PageHeading from '../../common/PageHeading'
import Divider from '../../../../../components/atoms/Divider'
import CatalogList from './CatalogList'

function CatalogHome () {
  return (
    <PageLayout className='font-serif' variant='constrained'>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <PageHeading title='AI Data Catalog' />
          <Divider />
        </Grid>
        <Grid item xs={12}>
          <CatalogList />
        </Grid>
      </Grid>
    </PageLayout>
  )
}

export default CatalogHome
